import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { moduloGaritas } from '../../diccionarios/balanzaModulo.js';
import { UtilsService } from '../../../../shared/utils/utils.service';
import { LfsaBotonEditarGridComponent} from '../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { formatDate } from '@angular/common';
import { ProveedorService } from '../../services/proveedor.service';
import { PlacaService } from '../../services/placa-transportista.service';
import { CedulaChoferService } from '../../services/cedula-chofer.service';
import { TanqueroService } from '../../services/tanquero.service';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';

@Component({
  selector    : 'app-mantenedor-tanqueros',
  templateUrl : './mantenedor-tanqueros.component.html',
  styleUrls   : ['./mantenedor-tanqueros.component.css'],
})

export class MantenedorTanquerosComponent implements OnInit {
  public loading    : boolean = false;
  public isCreated  : boolean = true;

  public DAT_TITULOS  : any = moduloGaritas.titulos.mantenerTanqueros;
  public DAT_BTNS     : any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS   : any = moduloGaritas.button.buttonsCss;
  public DAT_MSG      : any = moduloGaritas.mensajes;
  public tituloModal  : string;
  public DAT_AG_GRID  : any = moduloGaritas.agGrid;

  public columnDefs   : any[] = [];
  public rowData      : any[] = [];
  public gridApi      : any;
  public gridColumnApi: any;
  public frameworkComponents: any;

  public mantenerTanquerosForm = new FormGroup({
    identTanquero : new FormControl(''),
    numeroControl : new FormControl('', [Validators.required, Validators.maxLength(4)]),
    proveedor_ID  : new FormControl('', []),
    proveedor_RUC : new FormControl('', [Validators.required, Validators.maxLength(13)]),
    proveedor_DET : new FormControl('', [Validators.required]),
    tanqueroPlaca : new FormControl('', [Validators.required]),
    tanqueroTipo  : new FormControl(''),
    tanqueroMarca : new FormControl(''),
    tanqueroModelo: new FormControl(''),
    choferNCedula : new FormControl('', [Validators.required, Validators.maxLength(10)]),
    choferNombres : new FormControl(''),
    choferCelular : new FormControl(''),
    referenciaPro : new FormControl('', [Validators.required, Validators.maxLength(50)]),
    lugarLlegada  : new FormControl('', [Validators.required, Validators.maxLength(50)]),
    lugarSalida   : new FormControl('', [Validators.required, Validators.maxLength(50)]),

  });

  proveedorTransporteInvalido = false;

  constructor(
    private _util           : UtilsService,
    private tanqueroService : TanqueroService,
    private proveedorService: ProveedorService,
    private placaService    : PlacaService,
    private cedulaChoferS   : CedulaChoferService,
  ) { }

  get proveeTransporteControl() {
    return this.mantenerTanquerosForm.get('proveedor_RUC');
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefs = [
      {
        //headerName: 'Número de control',
        field: 'numeroTanquero',
        sortable: true,
        filter: true
      },
      {
        field: 'proveedor',
        sortable: true,
        filter: true,
        suppressSizeToFit: true,
        resizable: true,
      },
      {
        headerName: 'Chofer',
        field: 'cedula',
        //suppressSizeToFit: true,
        sortable: true,
        filter: true,
      },
      {
        field: 'placa',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 90,
        cellRendererParams: {
          onClick: this.editarTanquero.bind(this),
          label: 'Editar',
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        //cellStyle: {padding: 0},
        width: 90,
        cellRendererParams: {
          onClick: this.eliminarTicket.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger,
        }
      }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {
    this.mantenerTanquerosForm.get('identTanquero')?.disable({ onlySelf: true });
    this.gridComponent();
    this.obtenerTanqueros();
  }

  obtenerTanqueros() {
    this.loading = true;
    this.rowData = [];

    this.tanqueroService.obtener().subscribe(
      (resp) => {
        resp.map(item => {
          item["estado"] = (item["estado"] == 1) ? "ACTIVO" : "INACTIVO";
          return item;
        });

        console.log("AQUIII", resp)
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
  }


  buscarProveedor() {
    this.proveedorService.obtenerPorRuc(this.mantenerTanquerosForm.get('proveedor').value.trim()
    ).subscribe(
      resp => {
        if (resp) {
          this.mantenerTanquerosForm.get('detalleProveedor').setValue(`${resp.idProveedor.trim()} - ${resp.nombre.trim()}`);
          this.mantenerTanquerosForm.controls['proveedorId'].setValue(resp.idProveedor.trim());
          return;
        }
        this.mantenerTanquerosForm.get('detalleProveedor').reset();
        this._util.mensajeErroToast('Identificación del proveedor de compra incorrecto.');
      },
      error => {
        this.mantenerTanquerosForm.get('detalleProveedor').reset();
        this._util.mensajeErroToast('Identificación del proveedor de compra incorrecto.');
      }
    );
  }

  buscarPlacaTransporte() {
    this.placaService.obtenerPorPlaca(this.mantenerTanquerosForm.get('tanqueroPlaca').value.trim())
    .subscribe(
      resp => {
        if (resp) {
          this.mantenerTanquerosForm.get('tanqueroTipo' ).setValue(`${resp.tipoTransporte.trim()}`);
          this.mantenerTanquerosForm.get('tanqueroMarca').setValue(`${resp.marca.trim()}`);
          this.mantenerTanquerosForm.get('tanqueroModelo').setValue(`${resp.modelo.trim()}`);
          
          return;
        }
        this._util.mensajeErroToast('La placa es incorrecta.');
      },
      error => {
        this.mantenerTanquerosForm.get('tanqueroMarca').reset();
        this.mantenerTanquerosForm.get('tanqueroModelo').reset();
        this._util.mensajeErroToast('La placa es incorrecta.');
      }
    );
    // searchTransporte.value = 'Cod - Proveedor Transporte';
  }

  buscarCedulaChofer() {
    this.cedulaChoferS.obtenerPorCedula(
      this.mantenerTanquerosForm.get('choferNCedula').value.trim()
    ).subscribe(
      resp => {
        if (resp) {
          //console.log("CHOFER", resp)
          this.mantenerTanquerosForm.get('choferNombres').setValue(resp.idChofer.trim() + " - " + resp.nombres.trim());
          this.mantenerTanquerosForm.get('choferCelular').setValue(resp.fono ? resp.fono.trim(): resp.fono);
          
          return;
        }
        this.mantenerTanquerosForm.get('choferNombres').reset();
        this.mantenerTanquerosForm.get('choferNCedula').reset();
        this.mantenerTanquerosForm.get('choferCelular').reset();

        this._util.mensajeErroToast('La cédula es incorrecta.');
      },
      error => {
        this.mantenerTanquerosForm.get('choferNombres').reset();
        this.mantenerTanquerosForm.get('choferNCedula').reset();
        this.mantenerTanquerosForm.get('choferCelular').reset();
        
        this._util.mensajeErroToast('La cédula es incorrecta.');
      }
    );
  }

  guardarEditarTanquero() {
    this.loading = true;
    if (this.mantenerTanquerosForm.invalid) return;

    let obj = this.mantenerTanquerosForm.getRawValue();
    console.log("datosFormulario", obj);

    let data = {
      idTanquero          : obj.identTanquero,
      numeroTanquero      : obj.numeroControl,
      placa               : obj.tanqueroPlaca,
      proveedor           : obj.proveedor_ID,
      cedula              : obj.choferNCedula,
      referenciaProducto  : obj.referenciaPro,
      lugarSalida         : obj.lugarSalida,
      lugarLlegada        : obj.lugarLlegada
    };

    /*
    if(!this.isCreated){ 
      data.idTanquero = obj.identTanquero;
    };*/

    console.log("data", data);

    this._util
      .confirmarSincronoPromesa({
        title   : this.isCreated ? this.DAT_MSG.procesar : this.DAT_MSG.actualizar,
        text    : this.isCreated ? "Tanquero " + obj.numeroControl : obj.idTanquero,
        action  : this.isCreated ? this.DAT_BTNS.nuevo : this.DAT_BTNS.editar,
        funcion : this.isCreated ? this.tanqueroService.crear(data) : this.tanqueroService.editar(data),
      })
      .then(() => {
        this.obtenerTanqueros();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  eliminarTicket({ rowData }) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title   : this.DAT_MSG.eliminar,
        text    : `Ticket: ${rowData.idTanquero}`,
        action  : this.DAT_BTNS.eliminar,
        funcion : this.tanqueroService.borrar(rowData.idTanquero),
      })
      .then((res: any) => {
        this.obtenerTanqueros();
        this.loading = false;
        this.closeModal();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  nuevo(){
    this.isCreated = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.mantenerTanquerosForm.reset();
    //this.mantenerTanquerosForm.get('identTanquero').enable();
    this.openModal();
  }

  editarTanquero({rowData}){
    if (rowData.estado != 'ACTIVO'){
      this._util.mensajeErroToast('ACCIÓN INVALIDA');
      return;
    }

    this.isCreated = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.mantenerTanquerosForm.reset();
    this.mantenerTanquerosForm.patchValue(rowData);
    
    this.mantenerTanquerosForm.get('identTanquero').setValue(rowData.idTanquero);
    this.mantenerTanquerosForm.get('numeroControl').setValue(rowData.numeroTanquero);
    this.mantenerTanquerosForm.get('tanqueroPlaca').setValue(rowData.placa);
    this.mantenerTanquerosForm.get('choferNCedula').setValue(rowData.cedula);
    this.mantenerTanquerosForm.get('referenciaPro').setValue(rowData.referenciaProducto);

    this.tanqueroService.obtenerPorId(rowData.idTanquero).subscribe(
      respTanquero => {
        console.log("TANQUERO x ACTUALIZAR", respTanquero);
        if (respTanquero) {          
          if(respTanquero.proveedor != null){          
            this.proveedorService.obtenerPorId(respTanquero.proveedor).subscribe(
              resp => {
                this.mantenerTanquerosForm.get('proveedor_RUC').setValue(resp.ruc);
                this.onChangeProveedorTransporte(Event);
              });
          }
          
          this.loading = false;
          this.openModal();          
          this.buscarCedulaChofer();
          this.buscarPlacaTransporte();

          return;
        }

        this._util.mensajeErroToast('No se puede abir el registro');
        this.loading = false;

      }, error =>{
        this.loading = false;
      }
      
    );
    
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreated) this.guardarEditarTanquero();
    if (!this.isCreated) this.guardarEditarTanquero();
  }

  openModal() {
    document.getElementById('abrirModalAregarTicket').click();
  }

  closeModal() {
    document.getElementById('cerrarModalAgregarTicket').click();
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');
    let totalErrors = 0;

    Object.keys(this.mantenerTanquerosForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.mantenerTanquerosForm.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  onChangeProveedorTransporte(event: any) {
    this.getFormValidationErrors();

    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    
    if (this.proveeTransporteControl.value.trim() != null && this.proveeTransporteControl.value.trim().length > 12){
      
      this.proveedorService.obtenerPorRuc(this.proveeTransporteControl.value.trim()).subscribe(
        (resp) => {
          if (resp) {
            //console.log("RESP PROV TRA", resp)
            this.proveedorTransporteInvalido = false;
            this.mantenerTanquerosForm.controls['proveedor_DET'].setValue(resp.idProveedor + " - " + resp.nombre);
            this.mantenerTanquerosForm.controls['proveedor_ID'].setValue(resp.idProveedor.trim());

          } else {
            this.proveedorTransporteInvalido = true;
            this.mantenerTanquerosForm.controls['proveedor_DET'].setValue('');
            this._util.mensajeErroToast('Proveedor de transporte incorrecto.');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.proveedorTransporteInvalido = true;
          this.mantenerTanquerosForm.controls['proveedor_DET'].setValue('');
          this._util.mensajeErroToast('Proveedor de transporte incorrecto.');
        }
      );
    }else{

      this._util.mensajeErroToast('RUC requiere 13 digitos.');
      this.loading = false;

    }
  }


}
